import React from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import MultipleSimple from "../../../../../../media/images/icons/multiple-simple";

interface Props {
  handleRemoveFilter?: (key?: string) => void;
  item?: {
    filter: any | null;
    key: string;
  };
}
export default function FilterItem(props: Props) {
  const { handleRemoveFilter, item } = props;
  const theme = useTheme();
  return (
    <Box
      sx={{
        border: "1px solid gray",
        display: "flex",
        flexShrink: "0",
        // width: "50%",
        alignItems: "center",
        padding: "0px 0px 0px 4px",
        // paddingY: "4px",
        borderRadius: "8px",
        borderColor: "secondary.main",
        justifyContent: "space-between",
      }}
    >
      <IconButton
        size="small"
        onClick={() => handleRemoveFilter?.(item?.key)}
        aria-label="delete"
        color="primary"
      >
        <MultipleSimple size={20} color={theme.palette.error.main} />
      </IconButton>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {/* <TruckSpeedRight color={theme.palette.secondary.main} /> */}
        <Typography
          noWrap
          sx={{
            fontSize: "14px",
            fontWeight: "700",
          }}
          color="secondary.main"
        >
          {item?.filter.label}
        </Typography>
      </Box>
    </Box>
  );
}
